import { NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlimScrollModule } from 'ng2-slimscroll';
import {SharedModule} from './../shared/shared.module';
import { FacilityRoutingModule } from './facility-routing.module';
import { FacilityDashboardComponent } from './facility-dashboard/facility-dashboard.component';
import { FacilityRuleComponent } from './facility-rule/facility-rule.component';
import { Facility } from './facility';
import { EventComponent } from './event/event.component';
import { EventsDashboardComponent } from './event/events-dashboard/events-dashboard.component';
import { DecimalRestrictionDirective } from './../shared/decimal-restriction.directive';
import { EventBroadcastComponent } from './event/broadcast/event-broadcast.component';
import { ComposeMessageModule } from './../feed/compose-message/compose-message.module';
import { GroupBookingBroadcastComponent } from './group-booking/broadcast/booking-broadcast.component';
import { GroupBookingComponent } from './group-booking/booking.component';
import { GroupBookingDashboardComponent } from './group-booking/booking-dashboard/booking-dashboard.component';
import { LinkComponent } from './link/link.component';
import { LinkDashboardComponent } from './link/link-dashboard/link-dashboard.component';
import { LinkBroadcastComponent } from './link/broadcast/link-broadcast.component';
@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FacilityRoutingModule,
    SlimScrollModule,
    ComposeMessageModule
  ],
  declarations: [
    FacilityRuleComponent,
    FacilityDashboardComponent,
    EventComponent,
    EventsDashboardComponent,
    DecimalRestrictionDirective,
    EventBroadcastComponent,
    GroupBookingBroadcastComponent,
    GroupBookingComponent,
    GroupBookingDashboardComponent,
    LinkComponent,
    LinkDashboardComponent,
    LinkBroadcastComponent
  ]
})
export class FacilityModule { }



// WEBPACK FOOTER //
// ./src/app/facility/facility.module.ts